import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AgGridModule } from "ag-grid-angular";
import { MatComponentsModule } from "./../../mat-components.module";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { AsyncPipe, CommonModule, NgFor } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { ColorPickerDirective } from 'ngx-color-picker';
import { ClientModelComponent } from "./client-model/client-model.component";
import {
  MatDialogModule,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from "@angular/material/dialog";
import { ClientRolesComponent } from "./client-roles/client-roles.component";
import { CustomInputTypeModule } from "./custom-input-type/custom-input-type.module";
import { CommonFilterComponent } from "./common-filter/common-filter.component";
import { CommonSearchBarComponent } from "./common-search-bar/common-search-bar.component";
import { HoverOverComponent } from "./hover-over/hover-over.component";
import { ChartsModule } from "./charts/charts.module";
import { PipelineTooltipLinkComponent } from "./pipeline-tooltip-link/pipeline-tooltip-link.component";
import { AlertsTabComponent } from "./alerts-tab/alerts-tab.component";
import { PipelineUpdatePopupComponent } from "./pipeline-update-popup/pipeline-update-popup.component";
import { MatStepperModule } from "@angular/material/stepper";
import { PatientValueGetterComponent } from "./patient-value-getter/patient-value-getter.component";
import { PopupStatusComponent } from "./popup-status/popup-status.component";
import { AlertSettingsComponent } from './alert-settings/alert-settings.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatIconModule} from '@angular/material/icon';
import { MatTreeModule } from "@angular/material/tree";
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
// import { TransactionDetailPopupComponent } from './transaction-detail-popup/transaction-detail-popup.component';
import { PrescriberChangePopupComponent } from './prescriber-change-popup/prescriber-change-popup.component';
import { AlertIconComponent } from "./alert-icon/alert-icon.component";
import {MatBadgeModule} from '@angular/material/badge';
import { CustomTooltipDirective } from "src/app/directives/custom-tooltip.directive";
import { ScrollableItemDirective } from "src/app/directives/scrollable-item.directive";
import { AccordinColumnComponent } from "./accordin-column/accordin-column.component";
import { AlertIconsCommomComponent } from "./alert-icons-commom/alert-icons-commom.component";
import {OverlayModule} from '@angular/cdk/overlay';
// For the call panel's country picker (cdkMenu, as Case Management's menus use).
import { CdkMenuModule } from '@angular/cdk/menu';
import { LazyLoadDirective } from "src/app/directives/lazy-load.directive";
import {DragDropModule} from '@angular/cdk/drag-drop';
import { ConfigTypeSelectionComponent } from "./config-type-selection/config-type-selection.component";
import { WidgetHeaderConfigComponent } from "./widget-header-config/widget-header-config.component";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { AgRecordDetailsComponent } from "./ag-record-details/ag-record-details.component";
import { RouterModule } from "@angular/router";
import { SelectionPopupComponent } from "./selection-popup/selection-popup.component";
import { HoverOverClickComponent } from "./hover-over-click/hover-over-click.component";
import { IrCommectPopupComponent } from "./ir-comment-popup/ir-comment-popup.component";
import { PopupDeleteComponent } from "./popup-delete/popup-delete.component";
import { LongPressDirective } from "src/app/directives/long-press.directive";
import { FollowupPopupComponent } from "./follow-up-popup/follow-up-popup.component";
import { MatRadioModule } from "@angular/material/radio";
import { MatChipsModule } from "@angular/material/chips";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { FormlyModule } from "@ngx-formly/core";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
import { MatExpansionModule } from "@angular/material/expansion";
import { EdiitingGridPopupComponent } from './grid/ediiting-grid-popup/ediiting-grid-popup.component';
import { ValueAsIconSnippetComponent } from './value-as-icon-snippet/value-as-icon-snippet.component';
import { CustomChildGroupComponent } from './custom-child-group/custom-child-group.component';
import { PatientsFollowUpComponent } from "./patient-value-getter/patients-follow-up.component";
import { PatientsFlagsComponent } from "./patient-value-getter/patients-flag.component";
import { DetailGridEditingComponent } from "./grid/detail-grid-editing/detail-grid-editing.component";
import { ProgressIndefinite } from "./progress-indicator/indefinite";
import { CustomSnackbarComponent } from './custom-snackbar/custom-snackbar.component';
import { CustomTooltipOverDirective } from "src/app/directives/custom-tooltip-over.directive";
import { searchTextPipe } from "src/app/pipe/serach-filter.pipe";
import { MAT_TOOLTIP_DEFAULT_OPTIONS, MatTooltipDefaultOptions } from "@angular/material/tooltip";
import { AngularResizeElementModule } from "../../directives/resize-element";
import { AnnotationViewComponent } from './annotation-view/annotation-view.component';
import { AlertViewComponent } from './alert-view/alert-view.component';
import { ServerExportPopupComponent } from './server-export-popup/server-export-popup.component';
import { CommentsNotesComponent } from './comments-notes/comments-notes.component';
import { PatientsActionNotesComponent } from "./patient-value-getter/patients-action-notes.component";
import { ExpandThreadComponent } from "./comments-notes/expand-thread.component";
import { CommentsNotesService } from "./comments-notes/comments-notes.service";
import { IndividualNotesComponent } from "./comments-notes/individual-notes/individual-notes.component";
import { AlertViewService } from "./alert-view/alert-view.service";
import { BookmarkViewComponent } from './bookmark-view/bookmark-view.component';
import { BookmarkService } from "./bookmark-view/bookmark.service";
import { ObjectKeyCountPipe } from "src/app/pipe/object-key-count.pipe";
import { ShareByBookmarkComponent } from './bookmark-view/share-by-bookmark/share-by-bookmark.component';
import {ManageStatusesDialogComponent} from './manage-statuses-dialog/manage-statuses-dialog.component'
import { StatusSelectorComponent } from "./status-selector/status-selector.component";
import { HashtagService } from "./comments-notes/hashtag.service";
import { EventCalendarComponent } from "./calendar-events/event-calendar/event-calendar.component";
import { EventScheduleComponent } from './calendar-events/event-schedule/event-schedule.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { EventDialogComponent } from './calendar-events/event-dialog/event-dialog.component';
import { EventNewComponent } from './calendar-events/event-new/event-new.component';
import { MeetingJoinComponent } from './calendar-events/meeting-join/meeting-join.component';
import { SecureMessagePageComponent } from '../secure-message/secure-message-page.component';
import { MeetingRoomComponent } from './calendar-events/meeting-room/meeting-room.component';
import { MeetingChatComponent } from './calendar-events/meeting-chat/meeting-chat.component';
import { MeetingPeopleComponent } from './calendar-events/meeting-people/meeting-people.component';
import { MeetingTranscriptComponent } from './calendar-events/meeting-transcript/meeting-transcript.component';
import { MeetingDeviceSettingsComponent } from './calendar-events/meeting-device-settings/meeting-device-settings.component';
import { MeetingNeoComponent } from './calendar-events/meeting-neo/meeting-neo.component';
import { ClickToCallComponent } from './calendar-events/click-to-call/click-to-call.component';
import { VisitPlannerComponent } from './visit-planner/visit-planner.component';
import { VisitFormComponent } from './visit-planner/visit-form/visit-form.component';
import { VisitDetailComponent } from './visit-planner/visit-detail/visit-detail.component';
import { SecureMailComponent } from "./secure-mail/secure-mail.component";
import { MailPopupComponent } from './secure-mail/mail-popup/mail-popup.component';
import { SaveMailComponent } from './secure-mail/save-mail/save-mail.component';
import { MailTemplateComponent } from './secure-mail/mail-template/mail-template.component';
import { ConsentFormComponent } from "./secure-mail/consent-form/consent-form.component";
import { PrivacyPolicyComponent } from './secure-mail/privacy-policy/privacy-policy.component';
import { DeleteTemplateComponent } from './secure-mail/delete-template/delete-template.component';
import { EditTemplateComponent } from './secure-mail/edit-template/edit-template.component';
import { PreviewMailComponent } from './secure-mail/preview-mail/preview-mail.component';
import { DirectModule } from "../direct/direct.module";
import { PreferencesComponent } from './preferences/preferences.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { BottomGridSheetComponent } from './bottom-popup/bottom-grid-sheet/bottom-grid-sheet.component';
import { WidgetDirective } from "../widget/widget.directive";
import { LoginPopupComponent } from './login-popup/login-popup.component';
import { PatientsBadgesComponent } from "./patient-value-getter/patients-badge.component";
import { PatientsTrendIconComponent } from "./patient-value-getter/patients-trend-icon.component";

export const myCustomTooltipDefaults: MatTooltipDefaultOptions = {
  showDelay: 0,
  hideDelay: 0,
  touchendHideDelay: 1500,
  disableTooltipInteractivity:true 
};

@NgModule({
  declarations: [
    ClientModelComponent,
    ClientRolesComponent,
    ConfigTypeSelectionComponent,
    CommonFilterComponent,
    CommonSearchBarComponent,
    // PipelineTooltipLinkComponent,
    AlertsTabComponent,
    // PipelineUpdatePopupComponent,
    ManageStatusesDialogComponent,
    StatusSelectorComponent,
    HoverOverComponent,
    PatientValueGetterComponent,
    PopupStatusComponent,
    AlertSettingsComponent,
    PrescriberChangePopupComponent,
    AlertIconComponent,
    // CustomTooltipDirective,
    CustomTooltipOverDirective,
    LazyLoadDirective,
    ScrollableItemDirective,
    AccordinColumnComponent,
    // AlertIconsCommomComponent,
    WidgetHeaderConfigComponent,
    SelectionPopupComponent,
    HoverOverClickComponent,
    IrCommectPopupComponent,
    PopupDeleteComponent,
    AgRecordDetailsComponent,
    LongPressDirective,
    FollowupPopupComponent,
    ValueAsIconSnippetComponent,
    CustomChildGroupComponent,
    PatientsFollowUpComponent,
    PatientsFlagsComponent,
    EdiitingGridPopupComponent,
    DetailGridEditingComponent,
    CustomSnackbarComponent,
    searchTextPipe,
    AnnotationViewComponent,
    AlertViewComponent,
    ServerExportPopupComponent,
    CommentsNotesComponent,
    PatientsActionNotesComponent,
    ExpandThreadComponent,
    IndividualNotesComponent,
    BookmarkViewComponent,
    ObjectKeyCountPipe,
    ShareByBookmarkComponent,
    EventCalendarComponent,
    EventScheduleComponent,
    EventDialogComponent,
    EventNewComponent,
    MeetingJoinComponent,
    SecureMessagePageComponent,
    MeetingRoomComponent,
    MeetingChatComponent,
    MeetingPeopleComponent,
    MeetingTranscriptComponent,
    MeetingDeviceSettingsComponent,
    MeetingNeoComponent,
    ClickToCallComponent,
    VisitPlannerComponent,
    VisitFormComponent,
    VisitDetailComponent,
    SecureMailComponent,
    MailPopupComponent,
    SaveMailComponent,
    MailTemplateComponent,
    ConsentFormComponent,
    PrivacyPolicyComponent,
    DeleteTemplateComponent,
    EditTemplateComponent,
    PreviewMailComponent,
    PreferencesComponent,
    BottomGridSheetComponent,
    LoginPopupComponent,
    PatientsBadgesComponent,
    PatientsTrendIconComponent
  ],

  imports: [
    CommonModule,
    FormsModule,
    MatComponentsModule,
    AgGridModule,
    ChartsModule,
    MatButtonModule,
    MatDialogModule,
    CustomInputTypeModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatTreeModule,
    MatSelectModule,
    MatTabsModule,
    MatOptionModule,
    MatBadgeModule,
    OverlayModule,
    CdkMenuModule,
    DragDropModule,
    MatSlideToggleModule,
    MatSliderModule,
    NgSelectModule,
    RouterModule,
    NgMultiSelectDropDownModule.forRoot(),
    MatRadioModule,
    FormsModule,
    MatFormFieldModule,
    MatChipsModule,
    NgFor,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
    FormlyModule.forRoot(),
    FormlyBootstrapModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatExpansionModule,
    NgSelectModule,
    ProgressIndefinite,
    AngularResizeElementModule,
    ColorPickerDirective,
    MatButtonToggleModule,
    FullCalendarModule,
    WidgetDirective
  ],

  exports: [
    CommonFilterComponent,
    CommonSearchBarComponent,
    // PipelineTooltipLinkComponent,
    AlertsTabComponent,
    // PipelineUpdatePopupComponent,
    ManageStatusesDialogComponent,
    StatusSelectorComponent,
    MatStepperModule,
    PopupStatusComponent,
    PatientValueGetterComponent,
    AlertSettingsComponent,
    // TransactionDetailPopupComponent,
    PrescriberChangePopupComponent,
    AccordinColumnComponent,
    AlertIconComponent,
    // AlertIconsCommomComponent,
    WidgetHeaderConfigComponent,
    SelectionPopupComponent,
    HoverOverClickComponent,
    IrCommectPopupComponent,
    PopupDeleteComponent,
    AgRecordDetailsComponent,
    FollowupPopupComponent,
    ValueAsIconSnippetComponent,
    CustomChildGroupComponent,
    PatientsFollowUpComponent,
    PatientsFlagsComponent,
    EdiitingGridPopupComponent,
    DetailGridEditingComponent,
    searchTextPipe,
    AngularResizeElementModule,
    AnnotationViewComponent,
    AlertViewComponent,
    ServerExportPopupComponent,
    CommentsNotesComponent,
    PatientsActionNotesComponent,
    ExpandThreadComponent,
    IndividualNotesComponent,
    EventCalendarComponent,
    EventScheduleComponent,
    EventDialogComponent,
    EventNewComponent,
    MeetingJoinComponent,
    SecureMessagePageComponent,
    MeetingRoomComponent,
    ClickToCallComponent,
    VisitPlannerComponent,
    VisitFormComponent,
    VisitDetailComponent,
    SecureMailComponent,
    MailPopupComponent,
    SaveMailComponent,
    MailTemplateComponent,
    PrivacyPolicyComponent,
    DeleteTemplateComponent,
    EditTemplateComponent,
    PreviewMailComponent,
    BookmarkViewComponent,
    ShareByBookmarkComponent,
    BottomGridSheetComponent,
    PatientsBadgesComponent,
    PatientsTrendIconComponent
  ],
  bootstrap: [PipelineUpdatePopupComponent],
  providers: [provideNgxMask(), { provide: MatDialogRef, useValue: {} },  { provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: myCustomTooltipDefaults }, CommentsNotesService, AlertViewService, BookmarkService, HashtagService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class SharedComponentModule {}
